import * as APIRoutes from '@mm/api-routes';
import { CreatePageParams } from '../actions/PageCRUDActions';
import PageModel, { PageKind } from '../model/PageModel';
import AuthenticatedController from './AuthenticatedController';
import * as queryString from 'query-string';
import { ObjectUtils } from '@mm/utils';

export type CreatePageResponse = {
  errors: any[];
  page: PageModel;
  success: boolean;
};

export default class PageController extends AuthenticatedController {
  static getAll(
    chatbotId: number,
    kind?: PageKind,
    showHidden?: boolean,
  ): Promise<PageModel[]> {
    const params = { bot_id: chatbotId };
    if (kind) {
      params['kind'] = kind;
    }
    if (showHidden) {
      params['show_hidden'] = showHidden;
    }
    return super.get(APIRoutes.PAGES, params);
  }

  static batchRetrieveByIds(pageIds: number[]): Promise<PageModel[]> {
    return super.post(APIRoutes.BATCH_PAGES, pageIds);
  }

  static retrievePagesByGroupId(params: {
    pageGroupId: number;
    showWidgets?: true;
  }): Promise<PageModel[]> {
    const q = queryString.stringify(ObjectUtils.mapObjKeysToSnakeCase(params));

    return super.get(`${APIRoutes.PAGES}?${q}`);
  }

  static retrieveById(pageId: number): Promise<PageModel> {
    return super.get(APIRoutes.PAGE(pageId));
  }

  static postPage(entity: CreatePageParams): Promise<CreatePageResponse> {
    return super.post(APIRoutes.PAGES, entity);
  }

  static putPage(entity): Promise<PageModel> {
    return super.put(`${APIRoutes.PAGES}/${entity.id}`, entity);
  }

  static clone<T>(pageId: number, targetPageId?: number): Promise<T> {
    return super.post(`${APIRoutes.PAGES}/${pageId}/clone`, { targetPageId });
  }

  static patch(entities): Promise<PageModel[]> {
    return super.patch(`${APIRoutes.PAGES}/batch_update`, entities);
  }

  static deletePage(pageId: number): Promise<any> {
    return super.delete(`${APIRoutes.PAGES}/${pageId}`);
  }

  static getDropdownPages(
    chatbotId: number,
    showHidden?: boolean,
  ): Promise<PageModel[]> {
    const params = showHidden
      ? {
          bot_id: chatbotId,
          show_hidden: showHidden,
        }
      : { bot_id: chatbotId };
    return super.get(APIRoutes.DROPDOWN_PAGES, params);
  }

  static importFromSearchToken(pageId: number, searchToken: string) {
    return super.post(`${APIRoutes.PAGES}/${pageId}/import`, { searchToken });
  }
}
